export const USER_THEME_PREFERENCES = ['light', 'dark', 'system'] as const;

export type UserThemePreference = (typeof USER_THEME_PREFERENCES)[number];

export const DEFAULT_LANGUAGE = 'en';

export const SUPPORTED_LANGUAGES = ['en', 'de', 'fr'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export interface UserSettings {
  themePreference: UserThemePreference;
  language: SupportedLanguage;
}

export const DEFAULT_USER_SETTINGS: UserSettings = {
  themePreference: 'system',
  language: DEFAULT_LANGUAGE,
};
